import { render } from "./Accept-Payment.vue?vue&type=template&id=9fe84242"
import script from "./Accept-Payment.vue?vue&type=script&lang=js"
export * from "./Accept-Payment.vue?vue&type=script&lang=js"

import "./Accept-Payment.vue?vue&type=style&index=0&id=9fe84242&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__